namespace Gamification.Gamification {
    export interface TipologieCredenzialiRow {
        UserId?: number;
        TenantId?: number;
        IdTipologiaCredenziale?: number;
        Nome?: string;
        Descrizione?: string;
    }

    export namespace TipologieCredenzialiRow {
        export const idProperty = 'IdTipologiaCredenziale';
        export const nameProperty = 'Nome';
        export const localTextPrefix = 'Gamification.TipologieCredenziali';
        export const lookupKey = 'Gamification:TipologieCredenziali';

        export function getLookup(): Q.Lookup<TipologieCredenzialiRow> {
            return Q.getLookup<TipologieCredenzialiRow>('Gamification:TipologieCredenziali');
        }
        export const deletePermission = 'Gamification:Risorse';
        export const insertPermission = 'Gamification:Risorse';
        export const readPermission = 'Gamification:Risorse';
        export const updatePermission = 'Gamification:Risorse';

        export declare const enum Fields {
            UserId = "UserId",
            TenantId = "TenantId",
            IdTipologiaCredenziale = "IdTipologiaCredenziale",
            Nome = "Nome",
            Descrizione = "Descrizione"
        }
    }
}
